import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api, { API_BASE } from '../api';
import Layout from '../components/Layout';
import { useToast } from '../components/ToastContext';
import { useConfirm } from '../components/ConfirmModal';
import { T } from '../styles/theme';

export default function Bozze() {
  const [bozze, setBozze] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const { confirm, ConfirmDialog } = useConfirm();

  const load = () => {
    api.get('/annunci/bozze').then((r) => setBozze(Array.isArray(r.data) ? r.data : [])).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleDelete = async (id) => {
    const ok = await confirm('Eliminare questa bozza?');
    if (!ok) return;
    try { await api.delete(`/annunci/bozze/${id}`); toast.success('Bozza eliminata'); load(); }
    catch { toast.error('Errore eliminazione'); }
  };

  return (
    <Layout>

      {ConfirmDialog}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="page-title">Bozze Annunci</h1>
            <p className="text-sm mt-1" style={{ color: T.muted }}>{bozze.length} bozze salvate</p>
          </div>
          <Link to="/annunci/crea" className="btn-primary text-sm">+ Crea Annuncio</Link>
        </div>

        {loading ? (
          <div className="text-center py-12" style={{ color: T.muted }}>Caricamento...</div>
        ) : bozze.length === 0 ? (
          <div className="card p-12 text-center">
            <p className="text-lg mb-2" style={{ color: T.muted }}>Nessuna bozza</p>
            <Link to="/annunci/crea" className="text-sm hover:underline" style={{ color: T.violet }}>Crea il tuo primo annuncio</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {bozze.map((b) => (
              <div key={b.id} className="card p-4 flex items-center gap-4">
                <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0" style={{ backgroundColor: T.bg }}>
                  {b.product_foto_url ? <img src={`${API_BASE}${b.product_foto_url}`} alt="" className="w-full h-full object-cover" />
                  : <div className="w-full h-full flex items-center justify-center text-lg opacity-30">📦</div>}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm truncate" style={{ color: T.text }}>{b.titolo || b.product_name}</p>
                  <div className="flex gap-2 mt-1">
                    <span className={`badge ${b.piattaforma === 'ebay' ? 'badge-cyan' : 'badge-green'}`}>{b.piattaforma}</span>
                    <span className={`badge ${b.stato === 'pubblicato' ? 'badge-green' : 'badge-violet'}`}>{b.stato}</span>
                    <span className="text-xs" style={{ color: T.muted }}>€{b.prezzo?.toFixed(2)}</span>
                  </div>
                </div>
                <div className="flex gap-2">
                  {b.stato !== 'pubblicato' && (
                    <button onClick={() => handleDelete(b.id)} className="btn-danger text-xs">Elimina</button>
                  )}
                  {b.ebay_item_id && (
                    <a href={`https://www.ebay.it/itm/${b.ebay_item_id}`} target="_blank" rel="noopener noreferrer"
                      className="btn-ghost text-xs" style={{ color: T.cyan, borderColor: T.border }}>Vedi eBay</a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </main>    </Layout>
  );
}
